import React from 'react';

export const BookSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m12 4.992-.107-.132C11.14 3.956 9.881 3 8 3H6a4 4 0 0 0-4 4v8a4 4 0 0 0 3.999 4H8c1.846 0 2.547.46 2.793.707C11.162 20.228 11.15 21 12 21s.838-.771 1.207-1.293c.246-.246.947-.707 2.793-.707h2.001A4 4 0 0 0 22 15V7a4 4 0 0 0-4-4h-2c-1.881 0-3.14.956-3.893 1.86zM6 5a2 2 0 0 0-2 2v8a2 2 0 0 0 1.999 2H8c1.28 0 2.259.19 3 .503V7.188a4.396 4.396 0 0 0-.643-1.048C9.86 5.544 9.119 5 8 5zm7 12.503c.741-.312 1.72-.503 3-.503h2.001A2 2 0 0 0 20 15V7a2 2 0 0 0-2-2h-2c-1.119 0-1.86.544-2.357 1.14A4.4 4.4 0 0 0 13 7.188z"
            clipRule="evenodd"
        />
    </svg>
);
